// Roles screen, permission names and the role picker on Users.
export const rolesEn = {
  'roles.title': 'Roles',
  'roles.subtitle': 'What each kind of user may do. Administrator and Editor are built in; custom roles are for teams that need something in between.',
  'roles.new': 'New role',
  'roles.builtin': 'Built in',
  'roles.custom': 'Custom',
  'roles.col.name': 'Role',
  'roles.col.access': 'Access',
  'roles.col.users': 'Users',
  'roles.col.actions': 'Actions',
  'roles.admin.desc': 'Everything, including settings and users.',
  'roles.editor.desc': 'All content and navigation. No settings or users.',
  'roles.accessAll': 'Full access',
  'roles.accessCount': '{count} permissions',
  'roles.users': '{count} user|{count} users',
  'roles.edit': 'Edit',
  'roles.delete': 'Delete',
  'roles.delete.title': 'Delete the role {name}?',
  'roles.delete.body': 'This cannot be undone. Roles that are still assigned to users cannot be deleted.',
  'roles.toast.saved': 'Role saved',
  'roles.toast.deleted': 'Role deleted',
  'roles.locked': 'Custom roles are not part of your package. The built-in Administrator and Editor roles are always available.',
  'roles.form.newTitle': 'New role',
  'roles.form.editTitle': 'Edit {name}',
  'roles.form.name': 'Name',
  'roles.form.description': 'Description',
  'roles.form.permissions': 'Permissions',
  'roles.form.hint': 'Changing or deleting something needs permission to view it, so "View" is added automatically. Changes apply to users immediately.',
  'roles.form.submit': 'Save role',
  'roles.form.selectAll': 'All',
  'roles.area.pages': 'Pages',
  'roles.area.articles': 'Articles',
  'roles.area.catalogue': 'Catalogue',
  'roles.area.media': 'Media',
  'roles.area.inquiries': 'Quote requests',
  'roles.area.orders': 'Store orders and customers',
  'roles.area.mailbox': 'Inbox (email)',
  'roles.area.livechat': 'Live chat (website chat)',
  'roles.area.navigation': 'Header, footer and specifications',
  'roles.area.settings': 'Settings, tracking and content types',
  'roles.area.users': 'Users and roles',
  'roles.action.view': 'View',
  'roles.action.edit': 'Create and edit',
  'roles.action.publish': 'Publish',
  'roles.action.delete': 'Delete',
  'users.roleLabel': 'Role',
  'users.role.customSuffix': '{name} (custom)',
  'users.changeRole': 'Change role',
  'users.toast.roleChanged': 'Role changed',
  'content.editor.readOnly': 'You can view this but not change it.',
  'content.editor.noPublish': 'You can save changes but publishing needs another role.',
} as const

export const rolesId: Record<keyof typeof rolesEn, string> = {
  'roles.title': 'Peran',
  'roles.subtitle': 'Apa yang boleh dilakukan setiap jenis pengguna. Administrator dan Editor sudah tersedia; peran kustom untuk tim yang membutuhkan yang di antaranya.',
  'roles.new': 'Peran baru',
  'roles.builtin': 'Bawaan',
  'roles.custom': 'Kustom',
  'roles.col.name': 'Peran',
  'roles.col.access': 'Akses',
  'roles.col.users': 'Pengguna',
  'roles.col.actions': 'Aksi',
  'roles.admin.desc': 'Semuanya, termasuk pengaturan dan pengguna.',
  'roles.editor.desc': 'Semua konten dan navigasi. Tanpa pengaturan atau pengguna.',
  'roles.accessAll': 'Akses penuh',
  'roles.accessCount': '{count} izin',
  'roles.users': '{count} pengguna',
  'roles.edit': 'Ubah',
  'roles.delete': 'Hapus',
  'roles.delete.title': 'Hapus peran {name}?',
  'roles.delete.body': 'Tindakan ini tidak dapat dibatalkan. Peran yang masih dipakai pengguna tidak dapat dihapus.',
  'roles.toast.saved': 'Peran disimpan',
  'roles.toast.deleted': 'Peran dihapus',
  'roles.locked': 'Peran kustom tidak termasuk dalam paket Anda. Peran bawaan Administrator dan Editor selalu tersedia.',
  'roles.form.newTitle': 'Peran baru',
  'roles.form.editTitle': 'Ubah {name}',
  'roles.form.name': 'Nama',
  'roles.form.description': 'Deskripsi',
  'roles.form.permissions': 'Izin',
  'roles.form.hint': 'Mengubah atau menghapus sesuatu memerlukan izin untuk melihatnya, sehingga "Lihat" ditambahkan otomatis. Perubahan berlaku langsung bagi pengguna.',
  'roles.form.submit': 'Simpan peran',
  'roles.form.selectAll': 'Semua',
  'roles.area.pages': 'Halaman',
  'roles.area.articles': 'Artikel',
  'roles.area.catalogue': 'Katalog',
  'roles.area.media': 'Media',
  'roles.area.inquiries': 'Permintaan penawaran',
  'roles.area.orders': 'Pesanan dan pelanggan toko',
  'roles.area.mailbox': 'Kotak masuk (email)',
  'roles.area.livechat': 'Live chat (chat di website)',
  'roles.area.navigation': 'Header, footer, dan spesifikasi',
  'roles.area.settings': 'Pengaturan, pelacakan, dan tipe konten',
  'roles.area.users': 'Pengguna dan peran',
  'roles.action.view': 'Lihat',
  'roles.action.edit': 'Buat dan ubah',
  'roles.action.publish': 'Terbitkan',
  'roles.action.delete': 'Hapus',
  'users.roleLabel': 'Peran',
  'users.role.customSuffix': '{name} (kustom)',
  'users.changeRole': 'Ubah peran',
  'users.toast.roleChanged': 'Peran diubah',
  'content.editor.readOnly': 'Anda dapat melihat ini tetapi tidak dapat mengubahnya.',
  'content.editor.noPublish': 'Anda dapat menyimpan perubahan, tetapi menerbitkan memerlukan peran lain.',
}
